import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
};

export const dashboardAPI = {
  getStats: () => api.get('/admin/dashboard'),
  getReports: () => api.get('/admin/reports'),
};

export const usersAPI = {
  getAll: (params) => api.get('/admin/users', { params }),
  toggleBlock: (id) => api.put(`/admin/users/${id}/toggle-block`),
};

export const workersAPI = {
  getAll: () => api.get('/admin/workers'),
  getPending: () => api.get('/admin/workers/pending'),
  create: (data) => api.post('/admin/workers', data),
  approve: (id) => api.put(`/admin/workers/${id}/approve`),
  reject: (id) => api.put(`/admin/workers/${id}/reject`),
};

export const ordersAPI = {
  getAll: (params) => api.get('/admin/orders', { params }),
};

export const servicesAPI = {
  getAll: () => api.get('/services'),
  create: (data) => api.post('/services', data),
  update: (id, data) => api.put(`/services/${id}`, data),
  delete: (id) => api.delete(`/services/${id}`),
};

export const notificationsAPI = {
  send: (data) => api.post('/admin/notifications', data),
};

export default api;
